import*as e from"react";const t=({children:t,ssrFallback:r})=>{const[n,a]=e.useState(!1);return e.useEffect((()=>{a(!0)}),[]),n?e.createElement(e.Fragment,null,t):e.createElement(e.Fragment,null,r)};export{t as ClientOnly};
//# sourceMappingURL=ClientOnly.js.map
